<template>
    <div v-if="pembelian">
        <b-card class="m-0" no-body>
            <b-card-body>
                <div class="border border-dark">
                    <div class="row p-3">
                        <div class="col d-flex justify-content-center w-100">
                            <qrcode-vue :value="pembelian.code" size="800" class="qrcode" level="H"></qrcode-vue>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col w-100">
                            <table class="table table-borderless table-responsive h3 qrcode px-3">
                                <tr>
                                    <th class="text-nowrap">KODE</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.code }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">TANGGAL</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ formatDate(pembelian.created_at, 'DD / MM / YY') }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">GRADER</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.grader.name }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">SUPPLIER</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.supplier.name }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">GRADE</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.grade.name }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">BERAT</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ formatNumber(pembelian.bobot) }} KG</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">GUDANG</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.gudang.name }}</th>
                                </tr>
                                <template v-for="pindah in pembelian.pindah_gudangs">
                                    <tr class="border-top border-dark">
                                        <th class="text-nowrap">TANGGAL</th>
                                        <th class="px-3">:</th>
                                        <th class="text-nowrap w-100">{{ formatDate(pindah.created_at, 'DD / MM / YY') }}</th>
                                    </tr>
                                    <tr>
                                        <th class="text-nowrap">BERAT KIRIM</th>
                                        <th class="px-3">:</th>
                                        <th class="text-nowrap w-100">{{ formatNumber(pindah.bobot) }} KG</th>
                                    </tr>
                                    <tr>
                                        <th class="text-nowrap">GUDANG</th>
                                        <th class="px-3">:</th>
                                        <th class="text-nowrap w-100">PENGIRIMAN</th>
                                    </tr>
                                    <template v-if="pindah.pindah_gudang_tujuan">
                                        <tr class="border-top border-dark">
                                            <th class="text-nowrap">TANGGAL</th>
                                            <th class="px-3">:</th>
                                            <th class="text-nowrap w-100">{{ formatDate(pindah.pindah_gudang_tujuan.created_at, 'DD / MM / YY') }}</th>
                                        </tr>
                                        <tr>
                                            <th class="text-nowrap">BERAT TUJUAN</th>
                                            <th class="px-3">:</th>
                                            <th class="text-nowrap w-100">{{ formatNumber(pindah.pindah_gudang_tujuan.bobot) }} KG</th>
                                        </tr>
                                        <tr>
                                            <th class="text-nowrap">GUDANG</th>
                                            <th class="px-3">:</th>
                                            <th class="text-nowrap w-100">{{ pindah.gudang_tujuan.name }}</th>
                                        </tr>
                                    </template>
                                </template>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="border border-dark mt-3">
                    <div class="row">
                        <div class="col w-100">
                            <table class="table table-borderless table-responsive h3 px-3">
                                <tr>
                                    <th class="text-nowrap">TANGGAL</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ formatDate(pembelian.created_at, 'DD / MM / YY') }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">GRADER</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.grader.name }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">SUPPLIER</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.supplier.name }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">GRADE</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ pembelian.grade.name }}</th>
                                </tr>
                                <tr>
                                    <th class="text-nowrap">BERAT</th>
                                    <th class="px-3">:</th>
                                    <th class="text-nowrap w-100">{{ formatNumber(pembelian.bobot) }} KG</th>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="!editable || !noPrint" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Tutup</button>
                <button :disabled="isLoading" v-if="editable" @click="koreksi" type="button" class="btn btn-primary mr-2">Koreksi</button>
                <button :disabled="isLoading" v-if="!noPrint" @click="print" type="button" class="btn btn-primary mr-2">Cetak</button>
                <button :disabled="isLoading" v-if="noPrint && editable" @click="$emit('cancel')" type="button" class="btn btn-primary mr-2" data-dismiss="modal">Simpan</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';

export default {
    name: "pembelian-tembakau-viewer",

    props: {
        noPrint: {
            type: Boolean,
            default: false,
        },

        editable: {
            type: Boolean,
            default: true,
        },

        value: {
            type: Object,
            default: null,
        }
    },

    components: {
        QrcodeVue,
    },

    data() {
        return {
            pembelian: null,
        }
    },

    created() {
    },

    mounted() {
        this.pembelian = Object.assign({}, this.value);
    },

    computed: {
    },

    watch: {
        value() {
            this.pembelian = Object.assign({}, this.value);
        }
    },

    methods: {
        print() {
            let self = this;
            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pembelian-tembakaus/print/'+self.pembelian.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        koreksi() {
            this.$emit('koreksi', this.pembelian);
        }
    },
}
</script>
<style>
canvas, .qrcode {
    width: 100% !important;
    height: auto !important;
}

.qrcode th {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.table > tr > th {
    padding-left: 0;
    padding-right: 0;
}
</style>
